import { useMutation } from "@tanstack/react-query";
import { DefaultError } from "@tanstack/react-query/build/modern/index";
import { bulkUpdateOrdering } from "../api/bulkUpdateOrdering";
import {
  invalidateFaqGroupsQuery,
  setFaqGroupsQueryData,
} from "../queries/useFaqGroupsQuery";
import { FaqGroup } from "../types";

type Params = {
  faqGroups: FaqGroup[];
};

export const useReorderFaqGroupsMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (variables) => {
      const dataToUpdate = variables.faqGroups.reduce((acc, data) => {
        return {
          ...acc,
          [data.id]: { order: data.order },
        };
      }, {});

      setFaqGroupsQueryData(variables.faqGroups);

      await bulkUpdateOrdering(dataToUpdate);
    },
    onSettled: () => {
      invalidateFaqGroupsQuery();
    },
  });
};
